// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "city": {
      "column": {
        "default": null,
        "name": "city",
        "null": true,
        "type": "string"
      },
      "name": "city",
      "selected_by_default": null,
      "translated": null
    },
    "commune": {
      "column": {
        "default": null,
        "name": "commune",
        "null": true,
        "type": "string"
      },
      "name": "commune",
      "selected_by_default": null,
      "translated": null
    },
    "country": {
      "column": {
        "default": null,
        "name": "country",
        "null": true,
        "type": "string"
      },
      "name": "country",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "place_name": {
      "column": {
        "default": null,
        "name": "place_name",
        "null": true,
        "type": "string"
      },
      "name": "place_name",
      "selected_by_default": null,
      "translated": null
    },
    "region": {
      "column": {
        "default": null,
        "name": "region",
        "null": true,
        "type": "string"
      },
      "name": "region",
      "selected_by_default": null,
      "translated": null
    },
    "street": {
      "column": {
        "default": null,
        "name": "street",
        "null": true,
        "type": "string"
      },
      "name": "street",
      "selected_by_default": null,
      "translated": null
    },
    "zip_code": {
      "column": {
        "default": null,
        "name": "zip_code",
        "null": true,
        "type": "string"
      },
      "name": "zip_code",
      "selected_by_default": null,
      "translated": null
    },
    "human_friendly": {
      "column": null,
      "name": "human_friendly",
      "selected_by_default": false,
      "translated": null
    },
    "translated_country": {
      "column": null,
      "name": "translated_country",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "Address",
  "collectionKey": "addresses",
  "collectionName": "addresses",
  "i18nKey": "address",
  "camelizedLower": "address",
  "name": "Address",
  "nameDasherized": "address",
  "pluralName": "addresses",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "contact_address"
    },
    {
      "className": "ContactAddress",
      "collectionName": "contact_addresses",
      "foreignKey": "address_id",
      "name": "contact_address",
      "macro": "has_one",
      "resource_name": "ContactAddress",
      "through": null
    },
    {
      "className": "OrderDelivery",
      "collectionName": "order_deliveries",
      "foreignKey": "delivery_address_id",
      "name": "delivery_address_on_order_delivery",
      "macro": "has_one",
      "resource_name": "OrderDelivery",
      "through": null
    },
    {
      "className": "Order",
      "collectionName": "orders",
      "foreignKey": "invoice_address_id",
      "name": "invoice_address_on_order",
      "macro": "has_one",
      "resource_name": "Order",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "location_id",
      "name": "location_on_activities",
      "macro": "has_many",
      "resource_name": "Activity",
      "through": "contact"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "TenantContactSetting",
      "collectionName": "tenant_contact_settings",
      "foreignKey": "address_id",
      "name": "tenant_contact_setting",
      "macro": "has_one",
      "resource_name": "TenantContactSetting",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "city",
      "column": {
        "default": null,
        "name": "city",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "commune",
      "column": {
        "default": null,
        "name": "commune",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "country",
      "column": {
        "default": null,
        "name": "country",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "place_name",
      "column": {
        "default": null,
        "name": "place_name",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "region",
      "column": {
        "default": null,
        "name": "region",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "street",
      "column": {
        "default": null,
        "name": "street",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "zip_code",
      "column": {
        "default": null,
        "name": "zip_code",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "address",
  "primaryKey": "id"
}

/** Frontend model for Address. */
export default class Address extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  city() {
    return this.readAttributeUnderscore("city")
  }

  /** @returns {boolean} */
  hasCity() {
    const value = this.city()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  commune() {
    return this.readAttributeUnderscore("commune")
  }

  /** @returns {boolean} */
  hasCommune() {
    const value = this.commune()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  country() {
    return this.readAttributeUnderscore("country")
  }

  /** @returns {boolean} */
  hasCountry() {
    const value = this.country()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  placeName() {
    return this.readAttributeUnderscore("place_name")
  }

  /** @returns {boolean} */
  hasPlaceName() {
    const value = this.placeName()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  region() {
    return this.readAttributeUnderscore("region")
  }

  /** @returns {boolean} */
  hasRegion() {
    const value = this.region()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  street() {
    return this.readAttributeUnderscore("street")
  }

  /** @returns {boolean} */
  hasStreet() {
    const value = this.street()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  zipCode() {
    return this.readAttributeUnderscore("zip_code")
  }

  /** @returns {boolean} */
  hasZipCode() {
    const value = this.zipCode()

    return this._isPresent(value)
  }

  /** @returns {any} */
  humanFriendly() {
    return this.readAttributeUnderscore("human_friendly")
  }

  /** @returns {boolean} */
  hasHumanFriendly() {
    const value = this.humanFriendly()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedCountry() {
    return this.readAttributeUnderscore("translated_country")
  }

  /** @returns {boolean} */
  hasTranslatedCountry() {
    const value = this.translatedCountry()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static communeByCode(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "commune_by_code",
        collectionName: "addresses",
        type: "collection"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static findCityFromZipCode(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "find_city_from_zip_code",
        collectionName: "addresses",
        type: "collection"
      },
      commandArgs
    ))
  }
}
